import React, { useEffect, useState } from "react";
import axiosClient from "../../../axios-client";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";
import SideBar from "../SideBar";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Add icons from react-icons
const EditSingleReport = () => {
  const { state } = useLocation();
  const [initialState] = useState(state);
  console.log("initialState", initialState);
  const [report, setReport] = useState(() => ({
    category: initialState?.category || "",
    reportTitle: initialState?.reportTitle || "",
    reportCode: initialState?.reportCode || "",
    segments: initialState?.segments || [],
    summary: initialState?.summary || "",
    companies: initialState?.companies || [],
    regions: initialState?.regions || [],
    Title_year: initialState?.Title_year || [],
  }));
  const [expandedSegments, setExpandedSegments] = useState({});
  const [expandedSubSegments, setExpandedSubSegments] = useState({});
  const [expandedYears, setExpandedYears] = useState({});
  const [loading, setLoading] = useState(false); // Loading state
  const navigate = useNavigate(); // Navigation hook

  // Toggle collapsible sections
  const toggleExpand = (id, setExpanded, expanded) => {
    setExpanded({ ...expanded, [id]: !expanded[id] });
  };

  // Handle changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReport({ ...report, [name]: value });
  };

  const handleNestedChange = (e, index, field, type) => {
    const { name, value } = e.target;
    const updatedData = [...report[type]];
    updatedData[index][field][name] = value;
    setReport({ ...report, [type]: updatedData });
  };

  const handleSubSegmentYearChange = (
    e,
    segmentIndex,
    subSegmentIndex,
    yearIndex
  ) => {
    const { name, value } = e.target;
    const updatedSegments = [...report.segments];
    updatedSegments[segmentIndex].segments[
      subSegmentIndex
    ].subSegments[0].years[yearIndex][name] = value;
    setReport({ ...report, segments: updatedSegments });
  };

  const handleSummaryChange = (value) => {
    const sanitizedValue = DOMPurify.sanitize(value);
    setReport({ ...report, summary: sanitizedValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    try {
      const response = await axiosClient.put(
        `/reports/update/single/report/${state._id}`,
        report
      );

      if (response.status === 200) {
        console.log("Report updated successfully");
        navigate("/admin/report/view"); // Navigate to the desired page (e.g., '/reports')
      }
    } catch (error) {
      console.error("Error updating report:", error);
    } finally {
      setLoading(false); // Stop loading regardless of success or failure
    }
  };
  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);
  const toolbarOptions = [
    [{ header: [1, 2, 3, 4, 5, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"],
  ];

  const modules = {
    toolbar: {
      container: toolbarOptions,
    },
  };

  const handleYearChange = (e, index, field) => {
    const { value } = e.target;
    const updatedTitleYear = [...report.Title_year];
    updatedTitleYear[index][field] =
      field === "cagr" ? parseFloat(value) / 100 : value;
    setReport({ ...report, Title_year: updatedTitleYear });
  };

  const handleValueChange = (regionIndex, yearIndex, field, value) => {
    const updatedRegions = [...report.regions];
    if (field === "value") {
      updatedRegions[regionIndex].years[yearIndex].value = parseFloat(value);
    } else if (field === "year") {
      updatedRegions[regionIndex].years[yearIndex].year = parseInt(value, 10);
    }
    setReport({ ...report, regions: updatedRegions });
  };
  return (
    <>
      <SideBar />
      <div className="w-3/4 p-8 bg-gray-100 relative right-[-250px]" style={{width: "86%"}}>
        <h1 className="text-3xl font-bold text-center mb-6">Edit Report</h1>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Report Title */}
            <div>
              <label
                htmlFor="reportTitle"
                className="block text-lg font-medium mb-2"
              >
                Report Title
              </label>
              <input
                type="text"
                name="reportTitle"
                value={report.reportTitle}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md"
              />
            </div>
            {/* Summary with React Quill */}
            <div>
              <label
                htmlFor="summary"
                className="block text-lg font-medium mb-2"
              >
                Summary
              </label>
              <ReactQuill
                value={report.summary}
                onChange={handleSummaryChange}
                className="bg-white border border-gray-300 rounded-md"
              />
            </div>
            {/* Segments */}
            {/* Table for Title_year */}
            <div>
              <h2 className="text-xl font-bold mb-4">Yearly Data</h2>
              <table className="min-w-full table-auto border-collapse">
                
                <thead>
                  <tr>
                    <th className="border p-2">Year</th>
                    <th className="border p-2">Value</th>
                    <th className="border p-2">CAGR</th>
                  </tr>
                </thead>
                <tbody>
                  {report.Title_year.map((item, index) => (
                    <tr key={index}>
                      <td className="border p-2">
                        <input
                          type="number"
                          name="year"
                          value={item.year}
                          onChange={(e) => handleYearChange(e, index, "year")}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </td>
                      <td className="border p-2">
                        <input
                          type="number"
                          name="value"
                          value={item.value}
                          onChange={(e) => handleYearChange(e, index, "value")}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </td>
                      <td className="border p-2">
                        <input
                          type="number"
                          name="cagr"
                          value={(item.cagr * 100).toFixed(2)}
                          onChange={(e) => handleYearChange(e, index, "cagr")}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* <div className="w-3/4 p-8 bg-gray-100 relative "> */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Editable Table */}
                <div>
                  <h2 className="text-sm font-bold mb-4">Region Data</h2>
                  <table className="min-w-full table-auto border-collapse">
                    <thead>
                      <tr>
                        {/* <th className="border p-2">Region</th> */}
                        <th className="border p-2">Country</th>
                        {[...Array(10).keys()].map((yearOffset) => (
                          <th key={yearOffset} className="border p-2">
                            {2022 + yearOffset}
                          </th>
                        ))}
                        <th className="border p-2">CAGR (2023-2032)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {report.regions.map((region, regionIndex) => (
                        <tr key={regionIndex}>
                          {/* <td className="border p-1">{region.regionName}</td> */}
                          <td className="border p-1">{region.country}</td>
                          {region.years.map((yearData, yearIndex) => (
                            <td key={yearIndex} className="border p-2">
                              <input
                                type="number"
                                value={yearData.value || ""}
                                onChange={(e) =>
                                  handleValueChange(
                                    regionIndex,
                                    yearIndex,
                                    "value",
                                    e.target.value
                                  )
                                }
                                className="w-full p-2 border border-gray-300 rounded-md"
                              />
                            </td>
                          ))}
                          <td className="border p-2">
                            <input
                              type="number"
                              value={region.cagr || ""}
                              onChange={(e) =>
                                handleValueChange(
                                  regionIndex,
                                  -1,
                                  "cagr",
                                  e.target.value
                                )
                              }
                              className="w-full p-2 border border-gray-300 rounded-md"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </form>
            </div>
            {/* </div> */}
            {/* Segments */}
            <div>
              <label className="block text-lg font-medium mb-2">Segments</label>
              {report.segments.map((segment, segmentIndex) => (
                <div key={segmentIndex} className="space-y-4 border-b py-4">
                  <div>
                    {/* Expand/Collapse Button for Segment */}
                    <button
                      type="button"
                      onClick={() =>
                        toggleExpand(
                          segmentIndex,
                          setExpandedSegments,
                          expandedSegments
                        )
                      }
                      className="text-black underline"
                    >
                      {expandedSegments[segmentIndex]
                        ? `Collapse ${segment.country || "Segment"}`
                        : `Expand ${segment.country || "Segment"}`}
                    </button>
                  </div>
                  {/* Sub-Segment Content */}
                  {expandedSegments[segmentIndex] && (
                    <div>
                      <input
                        type="text"
                        name="country"
                        disabled
                        value={segment.country}
                        onChange={(e) =>
                          handleNestedChange(e, segmentIndex, null, "segments")
                        }
                        placeholder="Country"
                        className="w-full p-3 border border-gray-300 rounded-md"
                      />

                      {/* Loop through the subsegments and display their names */}
                      {segment.segments.map((subSegment, subSegmentIndex) => (
                        <div key={subSegmentIndex} className="ml-6">
                          <button
                            type="button"
                            onClick={() =>
                              toggleExpand(
                                `${segmentIndex}-${subSegmentIndex}`,
                                setExpandedSubSegments,
                                expandedSubSegments
                              )
                            }
                            className="text-black underline"
                          >
                            {expandedSubSegments[
                              `${segmentIndex}-${subSegmentIndex}`
                            ] ? (
                              <FaChevronUp /> // Use the collapse icon (up arrow)
                            ) : (
                              <FaChevronDown /> // Use the expand icon (down arrow)
                            )}
                            {subSegment.name || "Sub-Segment"}
                          </button>

                          {expandedSubSegments[
                            `${segmentIndex}-${subSegmentIndex}`
                          ] && (
                            <div>
                              <input
                                type="text"
                                name="name"
                                value={subSegment.name}
                                onChange={(e) =>
                                  handleNestedChange(
                                    e,
                                    segmentIndex,
                                    subSegmentIndex,
                                    "subSegment",
                                    "name"
                                  )
                                }
                                placeholder="Sub-Segment Name"
                                className="w-full p-3 border border-gray-300 rounded-md"
                              />

                              {/* Display the Subsegment Name directly below each subsegment */}
                              <div className="ml-6 text-black text-lg font-semibold mt-2">
                                Sub-Segment Name: {subSegment.name}
                              </div>

                              {/* Loop through subSubSegments if any */}
                              {subSegment.subSegments &&
                                subSegment.subSegments.map(
                                  (subSubSegment, subSubSegmentIndex) => (
                                    <div
                                      key={subSubSegmentIndex}
                                      className="ml-12 border-l pl-4"
                                    >
                                      {/* Expand/Collapse Button for Years */}
                                      <button
                                        type="button"
                                        onClick={() =>
                                          toggleExpand(
                                            `${segmentIndex}-${subSegmentIndex}-${subSubSegmentIndex}`,
                                            setExpandedYears,
                                            expandedYears
                                          )
                                        }
                                        className="text-black underline"
                                      >
                                        {expandedYears[
                                          `${segmentIndex}-${subSegmentIndex}-${subSubSegmentIndex}`
                                        ] ? (
                                          <FaChevronUp /> // Collapse icon
                                        ) : (
                                          <FaChevronDown /> // Expand icon
                                        )}
                                        Years Data {subSubSegment.name}
                                      </button>

                                      {expandedYears[
                                        `${segmentIndex}-${subSegmentIndex}-${subSubSegmentIndex}`
                                      ] && (
                                        <div>
                                          {subSubSegment.years.map(
                                            (year, yearIndex) => (
                                              <div
                                                key={yearIndex}
                                                className="flex gap-4"
                                              >
                                                <input
                                                  type="number"
                                                  name="year"
                                                  value={year.year}
                                                  onChange={(e) =>
                                                    handleSubSegmentYearChange(
                                                      e,
                                                      segmentIndex,
                                                      subSegmentIndex,
                                                      yearIndex
                                                    )
                                                  }
                                                  placeholder="Year"
                                                  className="w-1/3 p-3 border border-gray-300 rounded-md"
                                                />
                                                <input
                                                  type="number"
                                                  name="value"
                                                  value={year.value}
                                                  onChange={(e) =>
                                                    handleSubSegmentYearChange(
                                                      e,
                                                      segmentIndex,
                                                      subSegmentIndex,
                                                      yearIndex
                                                    )
                                                  }
                                                  placeholder="Value"
                                                  className="w-1/3 p-3 border border-gray-300 rounded-md"
                                                />
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )
                                )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Save Button */}
            <div className="text-center">
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded"
                disabled={loading} // Disable button when loading
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditSingleReport;
